package fyi.moko.hotpl.domain.model

/**
 * ── 가본 곳 / 안 가본 곳의 가름 기준 (R-11 · R-15) ──────────────────────────────
 *  · 명시적 `WISHLIST`가 먼저다 — 저장 화면의 "Want to go" 칩(0-22 방문 추론)이 정한 값.
 *  · 그 외에는 방문 기록이 한 건이라도 있는가로 가른다(2026-09-08 §10.2 결정 (b)).
 *    두 기준을 포갠 이유: 추론 이전에 저장된 장소는 전부 `VISITED` + 암묵적 첫 방문이라
 *    status만으로는 갈리지 않고, 반대로 방문 0건인 `VISITED`(Directory에서 담은 것)는
 *    아직 안 가본 곳이 맞다.
 *
 * Journal의 Been / Want to go 필터와 지도의 속 빈 핀이 **같은 함수**를 읽는다 — 둘이 어긋나면
 * 필터에는 남는데 핀은 다르게 그려지는 장소가 생긴다.
 */
fun Place.isWantToGo(visitCount: Int): Boolean =
    status == PlaceStatus.WISHLIST || visitCount == 0

fun Place.isWantToGo(summary: PlaceVisitSummary?): Boolean = isWantToGo(summary?.visitCount ?: 0)
